import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import * as styles from "./AccountingPostingVacantPositionModuleList.style.ts";
import { Suspense, useState } from "react";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { isInIframe, replacePathParams } from "@exonn/utils";
import type { AccountingPostingPositionResource } from "@exonn/js-sdk/src/namespaces/accounting-posting";
import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";

export const AccountingPostingVacantPositionModuleList = () => {
  const [selectedRow, setSelectedRow] =
    useState<AccountingPostingPositionResource>();
  const { router } = useDataRouterContext();
  const { t } = useTranslation();
  const handleEdit = (row: AccountingPostingPositionResource) => {
    if (isInIframe()) {
      window.parent.postMessage(
        {
          eventName: "OPEN_ERP2_ENTITY",
          payload: {
            resource: ResourceEnum.AccountingPosting,
            type: "edit",
            id: row.accounting_posting_id,
          },
        },
        "https://exonn.online",
      );
    } else {
      const route = createModuleRoutePaths({
        resource: ResourceEnum.AccountingPosting,
      });
      router.navigate(
        replacePathParams(route.edit.root, {
          id: row.accounting_posting_id,
        }),
      );
    }
  };
  return (
    <Suspense fallback={null}>
      <div css={styles.container}>
        <div css={styles.list}>
          <ResourceList
            onRowDoubleClick={(params) => {
              handleEdit(params.row);
            }}
            contextMenu={{
              selectedRow: selectedRow,
              onSelectedRowChange: setSelectedRow,
              items: [
                {
                  label: t("actions.edit", {
                    ns: TranslationNamespaceEnum.Common,
                  }),
                  icon: <i className={"icon-15-edit"} />,
                  key: "edit",
                  onSelect: handleEdit,
                },
              ],
            }}
            hideToolbarCreateNewRecordButton
            resource={ResourceEnum.AccountingPostingVacantPosition}
          />
        </div>
      </div>
    </Suspense>
  );
};
